// @ts-check

const STATUS_CONFIG = {
  to_do: {
    label: 'To Do',
    color: 'bg-muted text-foreground border-input',
  },
  in_progress: {
    label: 'In Progress',
    color: 'bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300 border-blue-300 dark:border-blue-800',
  },
  review: {
    label: 'Review',
    color:
      'bg-purple-100 dark:bg-purple-900/40 text-purple-800 dark:text-purple-300 border-purple-300 dark:border-purple-800',
  },
  done: {
    label: 'Done',
    color:
      'bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300 border-green-300 dark:border-green-800',
  },
  blocked: {
    label: 'Blocked',
    color: 'bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300 border-red-300 dark:border-red-800',
  },
};

const TaskStatusBadge = ({ status, size = 'md' }) => {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.to_do;

  const sizeClasses = {
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-0.5',
    lg: 'text-base px-3 py-1',
  };

  return (
    <span className={`inline-flex items-center rounded-full border font-medium ${config.color} ${sizeClasses[size]}`}>
      {config.label}
    </span>
  );
};

export default TaskStatusBadge;
